module.exports = __webpack_public_path__ + "img/sao-miguel-d-alfama.5fdb46b1.jpg";